import React, { Component } from "react";
import MembershipPricingServices from "../../../services/axiosServices/apiServices/MembershipPricingServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import Row3Input from "../../../components/membership/membershipPricing/Row3Input";
import { NavLink } from "react-router-dom";
import { CommonValidationMessages } from "../../../utils/Messages";
import { isValidForm, validate } from "../../../utils/validation/CommonValidator";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";

export default class CPASPricing extends Component {
    constructor(props) {
        super(props);
        this.membershipPricingServices = new MembershipPricingServices();
        this.swalServices = new SwalServices();

        this.state = {
            cpasPricingTable: {
                membershipCPASPricingId: 0,
                // A-Star Tier Fees
                aStarTierApplicationFee: 0,
                aStarTierAnnualRenewalFee: 0,
                aStarTierAppealFee: 0,
                // A Tier Fees
                aTierApplicationFee: 0,
                aTierAnnualRenewalFee: 0,
                aTierAppealFee: 0,
                // B Tier Fees
                bTierApplicationFee: 0,
                bTierAnnualRenewalFee: 0,
                bTierAppealFee: 0,
                // C Tier Fees
                cTierApplicationFee: 0,
                cTierAnnualRenewalFee: 0,
                cTierAppealFee: 0,
                updatedby: 0,
                updatedAppId: 0,
                createdBy: 0,
            },
            validationRule: {
                aStarTierApplicationFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                aStarTierAnnualRenewalFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                aStarTierAppealFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                aTierApplicationFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                aTierAnnualRenewalFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                aTierAppealFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                bTierApplicationFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                bTierAnnualRenewalFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                bTierAppealFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                cTierApplicationFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                cTierAnnualRenewalFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
                cTierAppealFee: [
                    {
                        type: "floatNumber",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "only numeric values"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }
    validateField = (key) => {
        const newValidState = validate(
            key,
            this.state.cpasPricingTable,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
    };

    handleChange(event) {
        const value = event.target.value;
        const name = event.target.name;
        const validated = value.match(/^(\d*\.{0,1}\d{0,2}$)/)
        if (validated) {
            let detail = this.state.cpasPricingTable;
            detail[name] = parseFloat(value);
            this.setState({ cpasPricingTable: { ...detail } });
        }
    }

    isValidateAllFields = () => {
        console.log("isValidateAllFields");
        const newValidState = isValidForm(
            this.state.cpasPricingTable,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    addEditCPASPricing = () => {
        const audit = getAuditContext()

        let isValid = this.isValidateAllFields();
        if (isValid) {
            let request = this.state.cpasPricingTable;
            request.updatedby = audit.adminUserId;
            request.updatedAppId =  audit.appId;
                 
            this.membershipPricingServices.addEditCPASPricing(request)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem != null) {
                        this.swalServices.Success(
                            "CPAS pricing updated successfully."
                        );
                    } else {
                        this.swalServices.Error(response.message);
                    }
                });
        }
    };

    getCpasPricing = () => {
        this.membershipPricingServices.getCpasPricing().then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                this.setState({
                    cpasPricingTable: response.responseItem.responseContent,
                });
            } else {
                this.swalServices.Error(response.message);
            }
        });
    };

    componentDidMount() {
        const audit = getAuditContext()

        // let cookie = getAuthProps();
        // const adminUserId = (cookie && cookie.adminUserId) ? Number(cookie.adminUserId) : 0;
        // if (adminUserId > 0) {
        //     this.setState({ createdBy: adminUserId });
        // }
        this.getCpasPricing();
        this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

    }

    render() {
        return (
            <>
                <div className="main-body-section">
                    <div className="bg-white">
                        <div className="heading-part pl-7 py-4 border-b">
                            <div className="flex items-center justify-between">
                                <h4 className="small-title font-bold theme-color">
                                    CPAS Pricing Table
                                </h4>
                            </div>
                        </div>
                        <div className="custom-card shadow-lg mb-10">
                            <div className="">
                                <div className="border pb-3 border-[#e0e0e0] border-solid border-section-main">
                                    <div className={`grid grid-cols-12 gap-6 h-[50px] bg-zinc-100 w-full items-center xl:pr-24 pr-8 pl-4 responsive-member-price-table`}>
                                        <div className="col-span-3">
                                            <h2 className="text-[#000000]">Tier Name</h2>
                                        </div>
                                        <div className="col-span-3">
                                            <h2 className="text-[#000000]">Application Fee</h2>
                                        </div>
                                        <div className="col-span-3">
                                            <h2 className="text-[#000000]">Annual Renewal Fee</h2>
                                        </div>
                                        <div className="col-span-3">
                                            <h2 className="text-[#000000]">Appeal Fee</h2>
                                        </div>
                                    </div>
                                    <div className="sign-icon-input pl-4 xl:pr-24 pr-8">
                                        <div className="">
                                            <Row3Input
                                                totalColumn={4}
                                                className="text-base text-[#000000]"
                                                caption="A-Star Tier"
                                                col1InputType="Money"
                                                col2InputType="Money"
                                                col3InputType="Money"
                                                col1FieldName="aStarTierApplicationFee"
                                                col2FieldName="aStarTierAnnualRenewalFee"
                                                col3FieldName="aStarTierAppealFee"
                                                col1value={this.state.cpasPricingTable.aStarTierApplicationFee}
                                                col2value={this.state.cpasPricingTable.aStarTierAnnualRenewalFee}
                                                col3value={this.state.cpasPricingTable.aStarTierAppealFee}
                                                validState={this.state.validState}
                                                handleChange={this.handleChange.bind(this)}
                                                validateField={this.validateField.bind(this)}
                                                error1={this.state.validState.error.aStarTierApplicationFee}
                                                error2={this.state.validState.error.aStarTierAnnualRenewalFee}
                                                error3={this.state.validState.error.aStarTierAppealFee}

                                            />
                                        </div>
                                    </div>
                                    <div className="sign-icon-input pl-4 xl:pr-24 pr-8">
                                        <div className="">
                                            <Row3Input
                                                totalColumn={4}
                                                className="text-base text-[#000000]"
                                                caption="A Tier"
                                                col1InputType="Money"
                                                col2InputType="Money"
                                                col3InputType="Money"
                                                col1FieldName="aTierApplicationFee"
                                                col2FieldName="aTierAnnualRenewalFee"
                                                col3FieldName="aTierAppealFee"
                                                col1value={this.state.cpasPricingTable.aTierApplicationFee}
                                                col2value={this.state.cpasPricingTable.aTierAnnualRenewalFee}
                                                col3value={this.state.cpasPricingTable.aTierAppealFee}
                                                validState={this.state.validState}
                                                handleChange={this.handleChange.bind(this)}
                                                validateField={this.validateField.bind(this)}
                                                error1={this.state.validState.error.aTierApplicationFee}
                                                error2={this.state.validState.error.aTierAnnualRenewalFee}
                                                error3={this.state.validState.error.aTierAppealFee}
                                            />
                                        </div>
                                    </div>
                                    <div className="sign-icon-input pl-4 xl:pr-24 pr-8">
                                        <div className="">
                                            <Row3Input
                                                totalColumn={4}
                                                className="text-base text-[#000000]"
                                                caption="B Tier"
                                                col1InputType="Money"
                                                col2InputType="Money"
                                                col3InputType="Money"
                                                col1FieldName="bTierApplicationFee"
                                                col2FieldName="bTierAnnualRenewalFee"
                                                col3FieldName="bTierAppealFee"
                                                col1value={this.state.cpasPricingTable.bTierApplicationFee}
                                                col2value={this.state.cpasPricingTable.bTierAnnualRenewalFee}
                                                col3value={this.state.cpasPricingTable.bTierAppealFee}
                                                validState={this.state.validState}
                                                handleChange={this.handleChange.bind(this)}
                                                validateField={this.validateField.bind(this)}
                                                error1={this.state.validState.error.bTierApplicationFee}
                                                error2={this.state.validState.error.bTierAnnualRenewalFee}
                                                error3={this.state.validState.error.bTierAppealFee}

                                            />
                                        </div>
                                    </div>
                                    <div className="sign-icon-input pl-4 xl:pr-24 pr-8">
                                        <div className="">
                                            <Row3Input
                                                totalColumn={4}
                                                className="text-base text-[#000000]"
                                                caption="C Tier"
                                                col1InputType="Money"
                                                col2InputType="Money"
                                                col3InputType="Money"
                                                col1FieldName="cTierApplicationFee"
                                                col2FieldName="cTierAnnualRenewalFee"
                                                col3FieldName="cTierAppealFee"
                                                col1value={this.state.cpasPricingTable.cTierApplicationFee}
                                                col2value={this.state.cpasPricingTable.cTierAnnualRenewalFee}
                                                col3value={this.state.cpasPricingTable.cTierAppealFee}
                                                validState={this.state.validState}
                                                handleChange={this.handleChange.bind(this)}
                                                validateField={this.validateField.bind(this)}
                                                error1={this.state.validState.error.cTierApplicationFee}
                                                error2={this.state.validState.error.cTierAnnualRenewalFee}
                                                error3={this.state.validState.error.cTierAppealFee}

                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <NavLink to="/Dashboard" className="btn btn-gray text-xl text-white">
                            {" "}
                            Back
                        </NavLink>
                        <button
                            className="text-lg font-bold btn btn-blue text-white"
                            onClick={() => this.addEditCPASPricing()}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </>
        );
    }
}
